import {InitPage} from "../index";

declare var $;
declare var App: any;
declare const tenantCode: string;

export interface LsUndoProgressChannelData {
    message: string;
    progress: number;
    state: string;
}

class LsUndoProgressUpdate {
    lsUndoProgressUpdateChannel: any;

    constructor() {
        this.lsUndoProgressUpdateChannel = App.cable.subscriptions.create(
            {
                channel: "Lightspeed::UndoProgressChannel",
                tenant_code: tenantCode
            },
            {
                connected() {
                    console.log("Connected to Lightspeed Undo Progress Update Channel");
                },
                disconnected() {
                    console.log("Disconnected to Lightspeed Undo Progress Update Channel");
                },
                received: (data: any) => this.updateProgress(data)
            }
        );
    }

    updateProgress(data: LsUndoProgressChannelData) {
        console.log(data);
        $("#ls_undo_progress").text(data.message);
        $(".progress-bar").css("width", `${data.progress}%`);
        $("#progressLabel").text(`${data.progress}%`)
        if ((data.state == "complete") && ($("#ls_undo_progress").length > 0)) {
            this.refresh();
        }
    }

    refresh(): void {
        window.location.reload();
    }
}

export function LoadPage() {
    InitPage("ls_qty_histories", () => {
        const m = new LsUndoProgressUpdate();
    });
}
